import { useEffect } from 'react'
import $ from 'jquery'
import { OptionsHOC } from '../../hocs'
import { triggerWindowEvent } from 'helpers/utils'

const ScriptInject = ({ getOption }) => {
  useEffect(() => {
    const headerScripts = getOption('headerScripts')

    if (headerScripts) {
      $('head').append(headerScripts)
      // Trigger window load manually to active any injected scripts
      triggerWindowEvent('load')
    }
  })

  return null
}

export default OptionsHOC(ScriptInject)
